"use client";
// F
import { FC, MouseEvent } from "react";
import { saveAs } from "file-saver";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";

import { useStyles } from "./styles";
import { useAppDispatch } from "@/redux/store";
import { generateAlert } from "@/redux/actions";

async function logInteraction() {
  try {
    await fetch(`${process.env.NEXT_PUBLIC_API_URL}/stats/image-download`, {
      method: "POST",
      credentials: "include",
    });
  } catch (error: unknown) {
    let errorMessage = "Failed to log image download interaction";
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    console.error(errorMessage);
  }
}

interface DownloadButtonProps {
  url: string;
  variant?: "button" | "icon";
  color?: string;
  className?: string;
}

const DownloadButton: FC<DownloadButtonProps> = ({
  url,
  variant = "button",
  color,
  className,
}) => {
  const { classes, cx } = useStyles({ color, variant });
  const dispatch = useAppDispatch();

  const handleClick = (e: MouseEvent<HTMLButtonElement | SVGSVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    performDownload();
  };

  const performDownload = async () => {
    try {
      const id = url.split("/").pop();
      const response = await fetch(url);
      const blob = await response.blob();
      saveAs(blob, `${id}.jpeg`);
      await logInteraction();
    } catch (error) {
      console.error(error);
      dispatch(
        generateAlert({
          text: "Failed to download image, please try again",
          type: "error",
        })
      );
    }
  };

  if (variant === "button") {
    return (
      <IconButton
        className={cx(classes.icon, className)}
        onClick={handleClick}
        aria-label="Download Image"
      >
        <DownloadIcon />
      </IconButton>
    );
  }

  return (
    <DownloadIcon
      className={cx(classes.icon, className)}
      onClick={handleClick}
      aria-label="Download Image"
    />
  );
};

export default DownloadButton;
